// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"81":"893a694e","141":"879504ff","168":"4b0c9a68","568":"a28fc65b","634":"edaa744b","659":"83fdb25e","715":"67495211","767":"e28b2189","939":"3e0f9389"}[chunkId] + ".chunk.css";
};